import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/tourall.jpg";

const PackageCategory = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Package Category - Holidays Maker Travel Agency"
        fallbackDescription="Explore travel packages that suit every journey with Holidays Maker Travel Agency. From honeymoon to business travel, we offer comprehensive travel solutions."
        fallbackKeywords="travel packages, honeymoon packages, family packages, adventure tours, business travel, domestic tours, international tours, Umrah packages, customized packages, Holidays Maker"
        fallbackOgTitle="Package Category - Holidays Maker Travel Agency"
        fallbackOgDescription="Find the perfect travel package for your journey. Comprehensive travel solutions for every type of traveler."
        fallbackCanonicalUrl="https://poliflytravels.com/package-category/"
      />

      <CommonBanner
        heading="Package Category"
        img={ImageConstants.visabanner}
        pagination="Package Category"
      />

      <section className="package-category-area pt-5 pb-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper visa-content">
                <h2 className="mb-4">Package Category Travel Your Way, Always.</h2>
                <h4 className="mb-3">Explore Travel Packages That Suit Every Journey</h4>
                <p className="mb-5">
                  At Holidays Maker Travel Agency, we understand that every traveler has a different reason to explore the world. Whether you're planning a romantic honeymoon, a family vacation, a business trip, or a spiritual journey, we offer a wide range of travel package categories to meet your needs.
                </p>
                <p className="mb-5">
                  Our travel experts have designed each package with care—focusing on comfort, convenience, and memorable experiences. You can choose from domestic tours, international holidays, customized packages, and more—all under one roof.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>

          </div>
          <div className='row mt-5 pb-5'>
            <div className='col-lg-6'>
            <div className="mb-5">
                  <h3 className="mb-3">Find the Right Package for You</h3>
                  <p>Here's an overview of the main travel package categories we offer:</p>
                  <ul className="benefits-list">
                    <li><strong>Honeymoon Packages:</strong> Specially designed for couples looking to celebrate love and togetherness. Visit romantic destinations like the Maldives, Turkey, or the northern areas of Pakistan with all arrangements taken care of.</li>
                    <li><strong>Family Packages:</strong> Fun-filled and safe tours for families with kids. Enjoy well-planned activities, comfortable stays, and hassle-free travel options tailored for every age group.</li>
                    <li><strong>Adventure & Leisure Tours:</strong> Perfect for thrill-seekers and nature lovers. Explore mountain trails, beaches, safaris, or just unwind at a resort. A mix of excitement and relaxation for solo travelers, groups, or couples.</li>
                    <li><strong>Business Travel:</strong> For professionals who travel for work. We arrange seamless business travel solutions, including hotel bookings, airport transfers, and meeting-ready accommodations.</li>
                  </ul>
                </div> 
                </div>
            <div className='col-lg-6'>  
            <div className="mb-5">
                  <h3 className="mb-3">More Package Categories</h3>
                  <ul className="benefits-list">
                    <li><strong>Domestic Tour Packages:</strong> Explore the hidden gems of Pakistan—from the green valleys of Swat and Hunza to the coastal beauty of Gwadar and Karachi. Affordable, accessible, and designed for local exploration.</li>
                    <li><strong>International Tour Packages:</strong> Travel across the globe with ease. From Asia to Europe, our international packages cover popular spots like Dubai, Malaysia, Turkey, and beyond.</li>
                    <li><strong>Umrah Packages:</strong> Spiritual journeys handled with care and respect. We offer affordable and premium Umrah packages with visa processing, hotel stays near Haram, and guided support.</li>
                    <li><strong>Customized Travel Packages:</strong> Don't see what you're looking for? We'll help you build a tour package from scratch. Choose your destination, dates, budget, and preferences—we'll handle the rest.</li>
                  </ul>
                </div>
              
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-6'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Why Choose Holidays Maker?</h3>
                  <ul className="benefits-list">
                    <li>Experienced Team to guide and support you</li>
                    <li>Visa and documentation support</li>
                    <li>Flexible travel options for every season and reason</li>
                    <li>Affordable prices without compromising on quality</li>
                    <li>24/7 customer support during your trip</li>
                  </ul>
                  <p className="mt-3">
                    We believe travel should be joyful, not stressful. Our focus is to give you the best value for your time and money.
                  </p>
                </div> </div>
            <div className='col-lg-6'>  
          
                <div className="get-in-touch mb-5">
                  <h3 className="mb-3">Book Your Preferred Travel Package Today!</h3>
                  <p>
                    Whether you're planning a quick getaway or a long vacation, Holidays Maker offers the best package categories to match your lifestyle, schedule, and travel goals. Let us help you plan your next journey the right way.
                  </p>
               
                </div>
            </div>
          </div>
         
        </div>
      </section>
    </>
  );
};

export default PackageCategory;